var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"half-circle-spinner",staticStyle:{"position":"absolute","bottom":"50%","right":"50%"}},[_c('div',{style:(_vm.divStyle)},[_c('div',{staticClass:"circle circle-1"}),_c('div',{staticClass:"circle circle-2"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }